(() => {
  'use strict';


  const section =
    document.querySelector(
      '#featured-colleges'
    );


  if (!section) return;


  function shouldRemove(
    element
  ) {

    /*
     * Never touch controls inside college cards.
     */
    if (
      element.closest(
        '.pn-college-card'
      )
    ) {
      return false;
    }


    /*
     * Keep the dedicated mobile swipe UI.
     */
    if (
      element.closest(
        '.pn-colleges__mobile-navigation'
      )
    ) {
      return false;
    }


    /*
     * Preserve Explore all colleges.
     */
    if (
      element.closest(
        '.pn-colleges__explore'
      )
    ) {
      return false;
    }


    const label =
      (
        element.getAttribute(
          'aria-label'
        ) || ''
      ).toLowerCase();


    const title =
      (
        element.getAttribute(
          'title'
        ) || ''
      ).toLowerCase();


    const className =
      typeof element.className ===
      'string'
        ? element.className
            .toLowerCase()
        : '';


    const text =
      (
        element.textContent ||
        ''
      )
        .trim()
        .toLowerCase();


    if (
      /previous|prev|next/.test(
        label
      )
      ||
      /previous|prev|next/.test(
        title
      )
      ||
      /(^|[-_\s])(prev|next)([-_\s]|$)/.test(
        className
      )
      ||
      /arrow[-_\s]?(left|right)/.test(
        className
      )
    ) {
      return true;
    }


    return [
      '←',
      '→',
      '‹',
      '›',
      '❮',
      '❯'
    ].includes(text);

  }


  function removeArrows() {

    section
      .querySelectorAll(
        'button, a, [role="button"]'
      )
      .forEach(
        element => {

          if (
            shouldRemove(
              element
            )
          ) {

            element.remove();

          }

        }
      );

  }


  removeArrows();


  /*
   * The live Supabase renderer can add the arrows
   * after initial page load.
   */
  const observer =
    new MutationObserver(
      () => {
        removeArrows();
      }
    );


  observer.observe(
    section,
    {
      childList:true,
      subtree:true
    }
  );

})();
